import { useUser } from '@clerk/react-router';
import { UserContextV2 } from '~/app';
import { LoadingSpinner } from '~/components/LoadingSpinner';
import { MarketContentPanel, MarketPanelHeader } from '~/features/shared/market-content';
import { AccountSettings } from './AccountSettings';
import { useProviderAccountName } from './useProviderAccountName';

// An employer's organization name lives in Employer Info, so the shared MCV wording about a
// credentialing profile does not apply to them. HLX providers keep the shared text.
const HLX_EMPLOYER_NAME_NOTE =
  'Note: Your name and photo will be displayed publicly so be careful what you share. Your organization name is managed in Employer Info.';

/** App-owned account settings shared by HLX employers and providers. */
export const HlxAccountSettings = () => {
  const { isLoaded, user } = useUser();
  const providerName = useProviderAccountName();
  const isEmployer = UserContextV2.useSelector((state) =>
    state.matches({ $_AUTHENTICATED: '$_AUTHENTICATED_EMPLOYER' })
  );

  if (!isLoaded || !user) {
    return <LoadingSpinner />;
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col" data-cy="hlx-account-settings">
      <MarketContentPanel header={<MarketPanelHeader title="Account settings" />}>
        <AccountSettings
          embedded
          user={user}
          nameNote={isEmployer ? HLX_EMPLOYER_NAME_NOTE : undefined}
          providerName={providerName}
          profileOnMcvHost
        />
      </MarketContentPanel>
    </div>
  );
};
